import React, { useState, useEffect, useRef } from 'react';

const ImageDiv = ({ imageUrl, children }) => {
  const [edgeColor, setEdgeColor] = useState(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const img = container.querySelector('img');
    if (!img) return;

    const extractColor = () => {
      try {
        if (img.naturalWidth > 0 && img.naturalHeight > 0) {
          const canvas = document.createElement('canvas');
          canvas.width = 1;
          canvas.height = 1;
          const context = canvas.getContext('2d');
          context.drawImage(img, 0, 0, 1, 1);
          const pixelColor = context.getImageData(0, 0, 1, 1).data;
          setEdgeColor(`rgb(${pixelColor[0]}, ${pixelColor[1]}, ${pixelColor[2]})`);
        }
      } catch (error) {
        console.error('Error extracting edge color:', error);
      }
    };

    if (img.complete && img.naturalWidth > 0) {
      extractColor();
    } else {
      img.addEventListener('load', extractColor);
      return () => img.removeEventListener('load', extractColor);
    }
  }, [imageUrl]);

  return (
    <div ref={containerRef} style={{ background: edgeColor }}>
      {children}
    </div>
  );
};

export default ImageDiv;